


















import {
  defineNuxtComponent,
  ref,
  onActivated,
  onDeactivated,
  onMounted,
  onUnmounted,
  computed
} from '~/utils/nuxt3-migration'
import { ciFilters } from '~/icons/source/regular/filters'
import { useNamespacedStore } from '~/compositions/store'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'

export default defineNuxtComponent({
  setup() {
    const {
      dispatch: classifiedSearchDispatch,
      getters: classifiedSearchGetters
    } = useNamespacedStore(CLASSIFIED_SEARCH_NS)

    const showLabel = ref(true)
    const lastScrollTop = ref(0)

    onMounted(() => {
      window.addEventListener('scroll', onScroll)
    })

    onUnmounted(() => {
      window.removeEventListener('scroll', onScroll)
    })

    onActivated(() => {
      window.addEventListener('scroll', onScroll)
    })

    onDeactivated(() => {
      window.removeEventListener('scroll', onScroll)
    })

    const selectedFacetsCount = computed(() =>
      classifiedSearchGetters('getFacetsCount')
    )

    function onScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop

      showLabel.value = scrollTop <= lastScrollTop.value

      lastScrollTop.value = scrollTop
    }

    function onClick() {
      classifiedSearchDispatch('toggleMobileFacets')
    }

    return {
      ciFilters,
      showLabel,
      selectedFacetsCount,
      onClick
    }
  }
})
